import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GroupesEntitesModel } from 'src/models/pilotage/groupesEntitesModel';
import { OrganisationModel } from 'src/models/pilotage/organisationModel';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {
  private baseUrl = environment.api_LMS + 'Organisation';

  constructor(private http: HttpClient) { }

  obtenirOrganisations(): Observable<GroupesEntitesModel> {
    return this.http.get<GroupesEntitesModel>(`${this.baseUrl}/ObtenirOrganisations`);
  }

  obtenirOrganisation(entiteId: number): Observable<OrganisationModel> {
    return this.http.get<OrganisationModel>(`${this.baseUrl}/ObtenirOrganisation`, { params: { entiteId: entiteId.toString() } });
  }

  majParametresEntite(entiteId: number, aUtilisateursFictifs: boolean, aAccesDiffusion: boolean, aAccesIndex: boolean, aTenantSSO: boolean): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/MAJParametresEntite`,
      { entiteId, aUtilisateursFictifs, aAccesDiffusion, aAccesIndex, aTenantSSO }
    );
  }
}
